import { MovesEnum } from 'shared/constants/shared-enums';

export const getMoveIconText = (move?: MovesEnum) => {
  switch (move) {
    case MovesEnum.Paper:
      return 'Paper';
    case MovesEnum.Rock:
      return 'Rock';
    case MovesEnum.Scissors:
      return 'Scissors';
    default:
      return null;
  }
};
